// extracted by mini-css-extract-plugin
module.exports = {"container":"tags_container__1uKdz","tag":"tags_tag__QQhOS","tagText":"tags_tagText__ImkF1"};